import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

export default function ProtectedRoute({ children, permissions = [] }) {
    const { me } = useOutletContext() || {};

    if (!me) return <Navigate to="/login" replace />;

    const userPerms = me.permissions?.map(p => p.name) || [];

    const hasAccess = permissions.length === 0 || permissions.some(p => userPerms.includes(p));
    if (!hasAccess) return <Navigate to="/" replace />;

    return children;
}

// Стартовая страница после входа и на корне сайта: «Аналитика», если на неё есть право, иначе «Личный кабинет».
// Условие то же, что у маршрута /analytics, иначе без права будет цикл через "/".
export function homePath(me) {
    const perms = me?.permissions?.map(p => p.name) || [];
    return perms.includes("reports.read") || perms.includes("messages.read") ? "/analytics" : "/me";
}

export function HomeRedirect() {
    const { me } = useOutletContext() || {};
    return <Navigate to={homePath(me)} replace />;
}
